import React from "react";
import { NavLink } from "react-router-dom";
import "./Footer.scss";
import Socials from "../Socials/Socials";
// assets
import logo from "../../assets/icons/logo.svg";

export default function Footer() {
	return (
		<footer className="footer py-5" >
			<div className="container  d-xl-flex justify-content-between">
				<div className="text-center">
					<NavLink className="fw--600 color--primary fz--18" to="/support">
						Need help?
					</NavLink>
					<Socials></Socials>
				</div>
				<div className="text-center order-xl-first">
					<NavLink to="/">
						<img src={logo} alt="Logo" className="footer__logo d-none d-xl-block" />
					</NavLink>
					<p className="color--primary opacity--03 fw--500 fz--14 mt-4">© KodjoEnglish.com | {new Date().getFullYear()}</p>
				</div>
			</div>
		</footer>
	);
}
